module.exports = __webpack_public_path__ + "media/images/share-icon-origin-89a2285c14d585ff97b026ce0538c3d9.png";